// extracted by mini-css-extract-plugin
export default {"ChangeLog":"changelog_ChangeLog__V9bMY","ChangeLogItem":"changelog_ChangeLogItem__Q617m"};